import { DOCIA_JOB_TITLES } from '@pflegia/types/api/job-title/data/docia-definition';
import { JobTitleEnum } from '@pflegia/types/api/job-title/job-titles.enum';
import { getEnumValues } from '@pflegia/util/common/enum/helpers';

export interface PositionClusterType {
  [key: string]: JobTitleEnum[];
}

const CARE_SUPPORT = 'Pflege und Betreuung';
const CARE_MANAGEMENT = 'Pflegeleitung';
const TRAINING = 'Weiterbildungen';

export const POSITION_CLUSTER_CARDS: PositionClusterType = {
  [CARE_SUPPORT]: [
    JobTitleEnum.Nurse,
    JobTitleEnum.RemedialCareNurse,
    JobTitleEnum.NursingSpecialistHealthCare,
    JobTitleEnum.Midwife,
    JobTitleEnum.AssistantElderlyCareNurse,
    JobTitleEnum.Companion,
    JobTitleEnum.PediatricNurse,
  ],
  [CARE_MANAGEMENT]: [
    JobTitleEnum.NursingSupervisor,
    JobTitleEnum.ResidentialSectorManager,
    JobTitleEnum.HomeManager,
    JobTitleEnum.TeamLeader,
  ],
  [TRAINING]: [JobTitleEnum.HygieneSpecialist, JobTitleEnum.QualityManagement, JobTitleEnum.PracticeManager],
};

export const POSITION_CLUSTER_CHIPS: JobTitleEnum[] = [
  JobTitleEnum.ElderlyCareNurse,
  JobTitleEnum.QualifiedDentalEmployee,
  JobTitleEnum.Nurse,
  JobTitleEnum.HomeManager,
  JobTitleEnum.MedicalAssistant,
  JobTitleEnum.OperationAssistant,
  JobTitleEnum.ResidentialSectorManager,
  JobTitleEnum.PharmaceuticalAssistant,
  JobTitleEnum.Paramedic,
  JobTitleEnum.SpeechTherapist,
  JobTitleEnum.PhysicalTherapist,
  JobTitleEnum.Midwife,
  JobTitleEnum.OccupationalTherapist,
  JobTitleEnum.UnitManager,
  JobTitleEnum.TechnicalAssistant,
  JobTitleEnum.AdministrativeStaff,
  JobTitleEnum.AnestheticAssistant,
];

const DOCIA_JOB_TITLE_TITLES = DOCIA_JOB_TITLES.map(jobTitle => jobTitle.title as JobTitleEnum);

export const POSITION_CLUSTER_CHIPS_EXPANDED = getEnumValues(JobTitleEnum, [...POSITION_CLUSTER_CHIPS, ...DOCIA_JOB_TITLE_TITLES]);

export const POSITION_CLUSTER_CHIPS_MOBILE: JobTitleEnum[] = [
  JobTitleEnum.ElderlyCareNurse,
  JobTitleEnum.Nurse,
  JobTitleEnum.PediatricNurse,
  JobTitleEnum.AssistantNurse,
  JobTitleEnum.AssistantElderlyCareNurse,
  JobTitleEnum.Instructor,
];

export const POSITION_CLUSTER_CHIPS_MOBILE_EXPANDED: JobTitleEnum[] = [
  JobTitleEnum.RemedialCareNurse,
  JobTitleEnum.HygieneSpecialist,
  JobTitleEnum.Others,
  JobTitleEnum.NursingSupervisor,
  JobTitleEnum.Companion,
  JobTitleEnum.OperationAssistant,
  JobTitleEnum.TeamLeader,
  JobTitleEnum.QualityManagement,
];

export const BUNDESLAND_CLUSTER: string[] = [
  'Bayern',
  'Sachsen',
  'Hessen',
  'Nordrhein-Westfalen',
  'Berlin',
  'Baden-Württemberg',
  'Brandenburg',
  'Bremen',
  'Hamburg',
  'Mecklenburg-Vorpommern',
  'Niedersachsen',
  'Rheinland-Pfalz',
  'Saarland',
  'Sachsen-Anhalt',
  'Schleswig-Holstein',
  'Thüringen',
];

export const BUNDESLAND_CLUSTER_MOBILE: string[] = ['Nordrhein-Westfalen', 'Bayern', 'Baden-Württemberg', 'Niedersachsen', 'Hessen'];

export const CITY_CLUSTER: string[] = ['Berlin', 'Düsseldorf', 'München', 'Leipzig', 'Bremen', 'Köln'];

// Demand-gap cities: regions with many open jobs but low candidate registrations (PFLGTG-2218).
export const DEMAND_GAP_CITY_CLUSTER: string[] = [
  'Kassel',
  'Münster',
  'Mainz',
  'Trier',
  'Paderborn',
  'Rosenheim',
  'Potsdam',
  'Braunschweig',
  'Dresden',
];
